module.exports = __webpack_public_path__ + "media/images/category/hobby-d3bc740918caed284cba2dc8ebf7e416.jpg";